// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"c174b9df","108":"4dab633d"}[chunkId] + ".chunk.css";
};